import sub_page_1 from "./sub_page_1";

export default sub_page_1;